import { useRef, useEffect } from 'react';

const APPLIED_LISTENERS = new Set();

/**
 * bind the given listener to keydown on the keyboard (while only ever
 * triggering the latest applied listener at any given click on the key).
 */
function useKeyListener(listener, {
  disabled = false,
  capture = false
} = {}) {
  const listenerRef = useRef(listener);
  useEffect(() => {
    listenerRef.current = listener;
  }, [listener]);
  useEffect(() => {
    if (disabled) {
      return;
    }
    APPLIED_LISTENERS.add(listenerRef);
    const handleKeyDown = evt => {
      if (!listenerRef.current || listenerRef !== getLastAddedItem(APPLIED_LISTENERS)) {
        // only the last applied clickOutside listener may be triggered in a
        // single click; otherwise we could accidentally close multiple layers
        // of ui at once even if that's not what the user intended to do
        return;
      }
      listenerRef.current(evt);
    };
    window.addEventListener("keydown", handleKeyDown, {
      capture
    });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, {
        capture
      });
      APPLIED_LISTENERS.delete(listenerRef);
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listenerRef, disabled]);
}
function getLastAddedItem(set) {
  const values = set.values();
  let prevValue;
  let currValue;
  do {
    prevValue = currValue;
    currValue = values.next();
  } while (currValue.done !== true);
  if (prevValue !== undefined) {
    return prevValue.value;
  }
}

export { useKeyListener };
//# sourceMappingURL=key-listener.js.map
